module.exports = __webpack_public_path__ + "img/order.935ed41e.png";